// NotificationSettingsPage.jsx
import React, { useState } from "react";
import { Tooltip } from "recharts"; 

const NotificationSettingsPage = () => {
 
  const [settings, setSettings] = useState({
    emailMarketing: true,
    smsMarketing: false,
    pushMarketing: true,
    emailSecurity: true,
    smsSecurity: true,
    pushSecurity: false,
    emailSystem: true,
    pushSystem: true,
  });

  const handleToggle = (key) => {
    setSettings({ ...settings, [key]: !settings[key] });
  };

  const handleSaveSettings = () => {
    console.log("Saved Settings:", settings);
    alert("Settings saved successfully!");
  };

  return (
    <div className="p-6 bg-white rounded-2xl shadow-md w-full mb-8 dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
    <div className="min-h-screen ">
      <h1 className="text-3xl font-bold mb-8 text-gray-800 dark:text-gray-200">Notification Settings</h1>

      {/* Notification Sections */}
      <div className="space-y-8">

        {/* Marketing Notifications */}
        <div className="bg-white p-6 rounded-xl shadow-md dark:bg-[#1A1A1B]">
          <h2 className="text-xl font-semibold mb-4 dark:text-gray-200" >Marketing Notifications</h2>
          <div className="space-y-4">
            {[
              { key: "emailMarketing", label: "Email", desc: "Receive marketing emails." },
              { key: "smsMarketing", label: "SMS", desc: "Receive marketing SMS." },
              { key: "pushMarketing", label: "Push", desc: "Receive push notifications for marketing." },
            ].map((item) => (
              <div key={item.key} className="flex items-center justify-between">
                <div className="w-[70%]">
                  <p className="font-medium dark:text-gray-300">{item.label}</p>
                  <p className="text-gray-500 text-sm dark:text-gray-400">{item.desc}</p>
                </div>
                {/* Switch */}
                <button
                  onClick={() => handleToggle(item.key)}
                  className={`w-14 h-7 rounded-full p-1 transition-colors duration-300 ${
                    settings[item.key] ? "agarly-gradient-bg" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`bg-white w-5 h-5 rounded-full shadow-md transform duration-300 ${
                      settings[item.key] ? "translate-x-7" : "translate-x-0"
                    }`}
                  ></div>
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Security Notifications */}
        <div className="bg-white p-6 rounded-xl shadow-md dark:bg-[#1A1A1B]">
          <h2 className="text-xl font-semibold mb-4 dark:text-gray-200">Security Notifications</h2>
          <div className="space-y-4">
            {[
              { key: "emailSecurity", label: "Email", desc: "Receive security alerts via email." },
              { key: "smsSecurity", label: "SMS", desc: "Receive security alerts via SMS." },
              { key: "pushSecurity", label: "Push", desc: "Receive push notifications for security." },
            ].map((item) => (
              <div key={item.key} className="flex items-center justify-between">
                <div className="w-[70%]">
                  <p className="font-medium dark:text-gray-300">{item.label}</p>
                  <p className="text-gray-500 text-sm dark:text-gray-400">{item.desc}</p>
                </div>
                {/* Switch */}
                <button
                  onClick={() => handleToggle(item.key)}
                  className={`w-14 h-7 rounded-full p-1 transition-colors duration-300 ${
                    settings[item.key] ? "agarly-gradient-bg" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`bg-white w-5 h-5 rounded-full shadow-md transform duration-300 ${
                      settings[item.key] ? "translate-x-7" : "translate-x-0"
                    }`}
                  ></div>
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* System Notifications */}
        <div className="bg-white p-6 rounded-xl shadow-md dark:bg-[#1A1A1B]">
          <h2 className="text-xl font-semibold mb-4 dark:text-gray-200">System Notifications</h2>
          <div className="space-y-4">
            {[
              { key: "emailSystem", label: "Email", desc: "Receive system updates via email." },
              { key: "pushSystem", label: "Push", desc: "Receive system push notifications." },
            ].map((item) => (
              <div key={item.key} className="flex items-center justify-between">
                <div className="w-[70%]">
                  <p className="font-medium dark:text-gray-300">{item.label}</p>
                  <p className="text-gray-500 text-sm dark:text-gray-400">{item.desc}</p>
                </div>
                {/* Switch */}
                <button
                  onClick={() => handleToggle(item.key)}
                  className={`w-14 h-7 rounded-full p-1 transition-colors duration-300 ${
                    settings[item.key] ? "agarly-gradient-bg" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`bg-white w-5 h-5 rounded-full shadow-md transform duration-300 ${
                      settings[item.key] ? "translate-x-7" : "translate-x-0"
                    }`}
                  ></div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={handleSaveSettings}
        className="mt-8 px-6 py-3 agarly-btn-primary text-agarly-dark font-semibold rounded-xl hover:bg-blue-700 transition"
      >
        Save Settings
      </button>
    </div>
    </div>
  );
};

export default NotificationSettingsPage;
